import { https } from "../http";
import store from "../store";
import {
  setCriticalAlerts,
  setCriticalAlertsLoading,
  setOverdueTasks,
  setOverdueTasksLoading,
  setTileData,
  setTileLoading,
} from "../store/reducers/skypointAlerts";
import { showError } from "../utils/index";

const buildQuery = (params = {}) => {
  const filtered = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  const qs = new URLSearchParams(filtered).toString();
  return qs ? `?${qs}` : "";
};

const getSkypointCriticalAlerts = async (params = {}) => {
  try {
    store.dispatch(setCriticalAlertsLoading(true));
    const response = await https().get(
      `/me/skypoint/critical-alerts${buildQuery(params)}`
    );
    if (response?.status === 200) {
      store.dispatch(setCriticalAlerts(response.data));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setCriticalAlertsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getSkypointOverdueTasks = async (params = {}) => {
  try {
    store.dispatch(setOverdueTasksLoading(true));
    const response = await https().get(
      `/me/skypoint/overdue-tasks${buildQuery(params)}`
    );
    if (response?.status === 200) {
      store.dispatch(setOverdueTasks(response.data));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setOverdueTasksLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const clearSkypointOverdueTasks = async () => {
  try {
    const response = await https().post(`/me/skypoint/overdue-tasks/clear`);
    if (response?.status === 200) return response.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return null;
  }
};

// Generic tile fetcher — `key` selects which Redux slice + endpoint to use.
// Path mapping: state key (camelCase) → URL slug (kebab-case).
const TILE_PATHS = {
  overdueNotes: "overdue-notes",
  pendingNotes: "pending-notes",
  missingCarePlans: "missing-care-plans",
  expiringDocuments: "expiring-documents",
  marCompletion: "mar-completion",
  docCompletion: "doc-completion",
};

const getSkypointTile = (key) => async (params = {}) => {
  const path = TILE_PATHS[key];
  if (!path) return;
  try {
    store.dispatch(setTileLoading({ key, loading: true }));
    const response = await https().get(
      `/me/skypoint/${path}${buildQuery(params)}`
    );
    if (response?.status === 200) {
      store.dispatch(setTileData({ key, data: response.data }));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setTileLoading({ key, loading: false }));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getSkypointOverdueNotes = getSkypointTile("overdueNotes");
const getSkypointPendingNotes = getSkypointTile("pendingNotes");
const getSkypointMissingCarePlans = getSkypointTile("missingCarePlans");
const getSkypointExpiringDocuments = getSkypointTile("expiringDocuments");
const getSkypointMarCompletion = getSkypointTile("marCompletion");
const getSkypointDocCompletion = getSkypointTile("docCompletion");

export {
  getSkypointCriticalAlerts,
  getSkypointOverdueTasks,
  clearSkypointOverdueTasks,
  getSkypointOverdueNotes,
  getSkypointPendingNotes,
  getSkypointMissingCarePlans,
  getSkypointExpiringDocuments,
  getSkypointMarCompletion,
  getSkypointDocCompletion,
};
